import { Link } from 'react-router-dom';
import React from 'react';

function Notation() {
  return (

    <div
      className="bg-notation-wrapper view"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-yellow.svg'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <main className="container" role="main">

        <Link to="/" className="back-btn">← Zurück</Link>
        <h1 className="section-title">Töne</h1>
     


     
          <div className="grid">


            {/* Lernfeld Tonhöhe */}
            <Link to="/notationlernfeld1" className="maincard card1" aria-label="notationlernfeld1">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-notation.png'} alt="notationlernfeld1" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Tonhöhe</h2>
                <p className="card__desc">Hohe und tiefe Töne unterscheiden</p>
              </div>
            </Link>

            {/* Lernfeld Tonlänge */}
            <Link to="/notationlernfeld3" className="maincard card3" aria-label="notationlernfeld3">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-notation.png'} alt="notationlernfeld3" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Tonlänge</h2>
                <p className="card__desc">Lange und kurze Töne unterscheiden.</p>
              </div>
            </Link>
          </div>
 </main>
        </div>
    

  );
}

export default Notation;